import { dataHooks } from '@wix/data-hooks';

export const briefPromoCardDataHooks = dataHooks<{
  boxContainer: {};
  cta: {};
  gif: {};
}>('brief-promo-card');
